import { Link, generatePath } from 'react-router-dom';
import moment from 'moment';
import Pill from 'components/common/pill/Pill';
import { DATE_FORMATS, VALUE_NA, VALUE_NA_TEXT } from 'reports/cw/constants/report.constant';
import { PerformancePath } from 'reports/cw/constants/cw.constant';
export var renderName = function (row) {
    var path = generatePath(PerformancePath.studentEngagement.studentDetail, {
        studentId: row.studentId.toString()
    });
    return (<div className="c-cw-engagement-table__student-name-cell" title={row.studentName}>
      <Link to={path}>
        <span>{row.studentName}</span>
      </Link>
      {row.isAtRiskStudent && <Pill className="c-cw-disengaged-pill">Disengaged</Pill>}
    </div>);
};
// Disengaged (at-risk) students first; students with the same status fall back to name order.
export var compareDisengagedStudent = function (s1, s2) {
    var riskDiff = Number(s2.isAtRiskStudent) - Number(s1.isAtRiskStudent);
    return riskDiff !== 0 ? riskDiff : (s1.studentName || '').localeCompare(s2.studentName || '');
};
export var renderAverageScore = function (row) {
    if (!row.avgScore) {
        return <span>{VALUE_NA_TEXT}</span>;
    }
    return <span>{"".concat(+(row.avgScore * 100).toFixed(0), "%")}</span>;
};
export var renderPastDue = function (row) {
    var colorClassName = +row.pastDue > 0 ? 'u-els-color-warn' : 'u-els-color-n6';
    return <span className={colorClassName}>{row.pastDue}</span>;
};
export var renderAssignmentsBelowClassAvg = function (row) {
    return <span>{row.totalAssignmentsBelowClassAvg}</span>;
};
export var renderLastLogin = function (row) {
    if (!row.lastLogin) {
        return <span>{VALUE_NA}</span>;
    }
    var lastLogin = moment(row.lastLogin);
    return <span>{lastLogin.isValid() ? lastLogin.format(DATE_FORMATS.TIMESTAMP) : VALUE_NA}</span>;
};
export var FLASH_CLASS = 'c-cw-engagement-table__cell--flash';
